import { render, staticRenderFns } from "./GoogleCalendar.vue?vue&type=template&id=d5136b7c&scoped=true&"
import script from "./GoogleCalendar.vue?vue&type=script&lang=js&"
export * from "./GoogleCalendar.vue?vue&type=script&lang=js&"
import style0 from "./GoogleCalendar.vue?vue&type=style&index=0&id=d5136b7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5136b7c",
  null
  
)

export default component.exports